import { render } from "./CategoryDrawerComponent.vue?vue&type=template&id=4a3a33e0"
import script from "./CategoryDrawerComponent.vue?vue&type=script&lang=js"
export * from "./CategoryDrawerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__